import * as React from 'react';
import { ArrowIcon } from '../../Icons/ArrowIcon';

export function ArrowButton(props: any) {
    const { className, style, onClick, classes } = props;

    return (
        <div
            className={`${className} ${classes.container}`}
            style={{ ...style }}
            onClick={onClick}
        >
            <ArrowIcon />
        </div>
    );
}
